var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.604 15V10Q11.604 9.646 11.865 9.385Q12.125 9.125 12.479 9.125Q12.833 9.125 13.094 9.385Q13.354 9.646 13.354 10V15L14.833 13.521Q15.083 13.271 15.438 13.26Q15.792 13.25 16.062 13.521Q16.312 13.771 16.312 14.135Q16.312 14.5 16.062 14.75L13.104 17.708Q12.979 17.833 12.812 17.906Q12.646 17.979 12.479 17.979Q12.312 17.979 12.146 17.906Q11.979 17.833 11.854 17.708L8.875 14.729Q8.625 14.5 8.646 14.146Q8.667 13.792 8.917 13.521Q9.167 13.271 9.521 13.271Q9.875 13.271 10.125 13.521ZM6.646 5 5.167 6.479Q4.917 6.729 4.573 6.729Q4.229 6.729 3.958 6.458Q3.708 6.208 3.708 5.844Q3.708 5.479 3.958 5.229L6.896 2.292Q7.042 2.146 7.198 2.083Q7.354 2.021 7.521 2.021Q7.688 2.021 7.844 2.083Q8 2.146 8.146 2.292L11.104 5.25Q11.354 5.5 11.365 5.844Q11.375 6.188 11.104 6.458Q10.854 6.708 10.49 6.708Q10.125 6.708 9.875 6.458L8.396 5V10Q8.396 10.354 8.135 10.615Q7.875 10.875 7.521 10.875Q7.167 10.875 6.906 10.615Q6.646 10.354 6.646 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcons);
export default __webpack_public_path__ + "static/media/swapIcons.3f131ed20bd89db4b3e343fa5846d34c.svg";
export { ForwardRef as ReactComponent };